import script from "./EmailVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailVerification.vue?vue&type=script&setup=true&lang=ts"

import "./EmailVerification.vue?vue&type=style&index=0&id=75ec1dda&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ec1dda"]])

export default __exports__